import axios from './axios'
import { Patient, VacciniTable } from '@/../../EshJSLib/models/patient'
import { TblVaccinazione } from '@/../../EshJSLib/models/patient'
import { Farmaci } from '@/../../EshJSLib/models/farmaciModel'

export async function saveVaccine(params: TblVaccinazione) {

    const json = JSON.stringify(params);
    const response = await axios.post(`/api/vaccini`, json);
    return response.data;
}

export async function filterVaccini(param: String): Promise<VacciniTable[]> {

    const json = JSON.stringify({search: param });
    const response = await axios.post(`/api/vaccinifilter`, json);
    return response.data.data as VacciniTable[];

}

export async function getVaccini() {
    const response = await axios.get(`/api/getVaccinis`) ;
    return response.data.data as TblVaccinazione[];
}